import React from 'react';
import './StoryPreview.css';
// Import the analytics utility in case we need it in the future
// import { trackStoryView } from '../../utils/analytics';

const StoryPreview = ({ stories, onStoryClick }) => {
  if (!stories || stories.length === 0) {
    return null;
  }

  // Get current time for scheduled publishing check
  const now = new Date();

  // Filter out disabled, empty stories, and stories outside their scheduled publish window
  const validStories = stories.filter(story => {
    // Filter out disabled and empty stories
    if (story.disabled || story.items.length === 0) {
      return false;
    }

    // Check if the story has scheduled publish times
    if (story.publishStartTime && story.publishEndTime) {
      try {
        // Parse the ISO strings directly - this will correctly handle the timezone
        const startTime = new Date(story.publishStartTime + "Z");
        const endTime = new Date(story.publishEndTime + "Z");
        
        // Only include if current time is within the publish window
        return now >= startTime && now <= endTime;
      } catch (error) {
        console.error("Error checking schedule window in preview:", error);
        return false;
      }
    }

    // Include regular published stories
    return true;
  });
  
  if (validStories.length === 0) {
    return null;
  }

  return (
    <div className="story-preview-container">
      <div className="story-preview-scroll">
        {validStories.map((story) => (
          <div
            key={story.id}
            className="story-preview-item"
            onClick={() => {
              // Just call the original click handler without tracking
              // The view will be tracked in the StoryViewer component
              onStoryClick(story.id);
            }}
          >
            <div className="story-preview-circle">
              <img
                src={story.circularImageUrl}
                alt={story.text || ''}
                className="story-preview-image"
              />
            </div>
            <div className="story-preview-text">
              {story.text || ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StoryPreview;